import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result, ResultList } from 'app/models';
import { TicketService } from 'app/services';

@Component({
  selector: 'app-sub-ticket-detail',
  templateUrl: './sub-ticket-detail.component.html',
  styleUrls: ['./sub-ticket-detail.component.scss']
})
export class SubTicketDetailComponent implements OnInit {

  public isBusy: boolean = false;
  public subTicketList: ResultList<Number> = new ResultList<Number>();

  @Input()
  public ticketHeaderId: Number = 0;

  constructor(
    private modalService: NgbModal,
    private ticketService: TicketService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.getSubTicketList(this.ticketHeaderId);
  }

  navigateToSaveTicket() {
    this.router.navigate(['../dashboard/save-ticket', { headerId: this.ticketHeaderId }]);
    this.modalService.dismissAll();
  }

  public getSubTicketList(headerId:Number): void {
    this.ticketService.getSubTicketList(headerId).then(result => {
      if (result.success === true) {
        this.subTicketList = result;
      } else {
        this.subTicketList = result;
      }
    });
  
  }

  public getTicketByTicketId(ticketId : Number): void {
    this.router.navigate(['../dashboard/ticket-list', {ticketId: ticketId}]);
    this.modalService.dismissAll();
  }


}
